import React from 'react';
import CardHeader from "@mui/material/CardHeader";
import PropTypes from 'prop-types';

const MessagesHeader = ({ length }) => {
    return (
        <CardHeader
            title={"Notifications"}
            subheader={`${length} new notifications`}
            sx={{
                '& .MuiCardHeader-action': {
                    alignSelf: 'center',
                }
            }}
        />
    );
};

MessagesHeader.propTypes = {
    length: PropTypes.number
}

export default MessagesHeader;
